import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatLabel } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ApiService } from '../shared/services/api.service';
import { CommonService } from '../shared/services/common.service';
import { Router } from '@angular/router';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';

@Component({
  selector: 'app-staff-list',
  imports: [
    MatCardModule,
    MatTableModule,
    MatButtonModule,
    MatMenuModule,
    CommonModule,
    MatSelectModule,
    FormsModule,
    MatPaginatorModule
  ],
  templateUrl: './staff-list.component.html',
  styleUrl: './staff-list.component.scss'
})
export class StaffListComponent {

  displayedColumns: string[] = [
    'actions','name', 'staff_id', 'phone',
    'designation', 'course_ids', 'email'
  ];
  users: any;
  dataSource = new MatTableDataSource<any>();

  constructor(private api: ApiService, private common: CommonService, private router: Router){ }

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  ngOnInit() {
    this.getStaffList();
  }

  getStaffList(){
    this.api.get('user/staffList').subscribe(resp => {
      if(resp.success){
        this.users = resp.data;
        this.dataSource.data = this.users;
        this.dataSource.paginator = this.paginator;
      }
    })
  }

  onView(user_id: string) {
    console.log('Id :', user_id);
    this.router.navigate(['/profile/user-profile'],{
      queryParams: { id: user_id}
    })
  }

  onActiveInActive(user_id: string, is_active: boolean){
    console.log("Id : ", user_id);
    this.api.put(`user/updateActivation`,{ id: user_id, is_active: !is_active}).subscribe(resp => {
      if(resp.status){
        this.common.notification('Updated the profile');
        this.getStaffList();
      }else{
        this.common.notification('Please try again later');
      }
    })
  }
 
}
